import styled from "styled-components";
import SwiperCore, { Navigation } from "swiper";
import "swiper/components/navigation/navigation.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { IconLoadMore } from "@components";
import { IReward } from "@interfaces";
import { Spin } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import { RewardItem } from "./Item";

SwiperCore.use([Navigation]);

interface IProps {
    data: IReward[];
    handleClick: (value: IReward, check: boolean) => void;
    onLoadMore: () => void;
    rTotal: number;
    loadingPagination: boolean;
}

export const ComponentRewardList = (props: IProps) => {
    const { data, handleClick, onLoadMore, rTotal, loadingPagination } = props;

    return (
        <StyledContainer className="detail-use-point">
            <InfiniteScroll
                dataLength={data.length}
                next={onLoadMore}
                hasMore={true}
                loader={
                    loadingPagination && (
                        <div className="example">
                            <Spin
                                size="large"
                                spinning={loadingPagination}
                                indicator={<IconLoadMore />}
                            />
                        </div>
                    )
                }
                height="67dvh"
            >
                <div className="grid-2fr">
                    {data.map((values, index) => {
                        if (values?.isMissionOnly) {
                            return;
                        }
                        return (
                            <div key={index}>
                                <RewardItem
                                    data={values}
                                    handleClick={handleClick}
                                    lastItem={index === data.length - 1}
                                />
                            </div>
                        );
                    })}
                </div>
            </InfiniteScroll>
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    .grid-2fr {
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 0 15px 25px;
        position: relative;
        column-gap: 15px;
        row-gap: 15px;
    }
    .empty {
        min-height: 10dvh;
    }
    .infinite-scroll-component::-webkit-scrollbar {
        display: none !important;
    }
    .load-more {
        margin: 20px;
    }
    .wrapper {
        margin: 0 0 24px 15px;
    }
    .money {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5rem;
        color: #a7a7a7;
        margin-bottom: 8px;
        word-spacing: -1px;
    }
    .list-reward {
        display: flex;
    }
    .swiper-slide {
        height: unset;
        width: auto !important;
    }
    .control-list {
        display: inline-block;
    }
`;
